<template>
  <div id="footer">
    <div class="footer_wrap">
      <!-- <div class="footer_contents">
        <div class="sns_btn_group">
          <a class="sns_btn yt" :href="location('yt')" target="_blank" rel="nofollow"></a>
          <a class="sns_btn is" :href="location('is')" target="_blank" rel="nofollow"></a>
					<a class="sns_btn na" :href="location('na')" target="_blank" rel="nofollow"></a>
        </div>
      </div> -->
      <div class="footer_contents">
        <div class="footer_item link_area">
          <div
            class="sub_link"
            v-for="(link, idx) in links"
            :key="`sub_menu_${idx}`"
          >
            <a :class="{ active: currentPage == link.path }" :href="link.path">
              {{ link.name }}
            </a>
          </div>
        </div>
        <div class="footer_item">
          <span> 1833-8910 (평일 09:00 ~ 18:00) </span>
          <span> (주)스포티비 | 대표 : 홍우승 </span>
          <span>
            03924 서울시 마포구 월드컵북로 56길 12 상암동 TRUTEC 빌딩 5층
          </span>
        </div>
        <div class="footer_item">
          <span> Copyright ⓒ 2025 SPOTV PLUS. All rights reserved</span>
        </div>
      </div>
      <div class="footer_contents">
        <div
          class="footer_logo"
          @click="$router.push('/').catch(() => {})"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "@/helpers/utils";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      currentPage: null,
      links: [
        { name: "광고문의", path: "/advertise" },
        { name: "사업제휴문의", path: "/contact" },
        { name: "오시는 길", path: "/location" },
      ],
    };
  },
  created() {
    this.checkActive(this.$route.path);
  },
  methods: {
    location(type) {
      let link = Utils.getSns()[type];
      // window.open(link,'_blank')
      return link;
    },
    move(path) {
      this.currentPage = path;
      this.$router.replace(`${path}`).catch(() => {});
    },
    checkActive(path) {
      if (_.some(this.links, { path: path })) {
        this.currentPage = path;
      } else {
        this.currentPage = null;
      }
    },
  },
  watch: {
    $route(to, from) {
      this.checkActive(to.path);
    },
  },
};
</script>
<style lang="less">
#footer {
  margin: auto;
  width: 100%;
  min-width: 1400px;
  max-width: 1920px;
  position: relative;
  background-color: #f8f8f8;
  .footer_wrap {
    margin: auto;
    padding-top: 50px;
    padding-bottom: 100px;
    width: 453px;
    display: flex;
    justify-content: center;
    flex-flow: column wrap;
    border-top: 1px solid #ffffff;
    .footer_contents {
      display: flex;
      flex-flow: column wrap;
      align-items: center;
      justify-content: center;
      transform: skew(-0.05deg);
      .footer_logo {
        width: 206px;
        height: 60px;
        background-image: url("~@/assets/image/footer/SPOTV PLUS_footer.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        margin-top: 30px;
        cursor: pointer;
      }
      .footer_item {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-flow: row wrap;
        color: #8f8f8f;
        font-size: 16px;
        font-weight: 400;

        &.link_area {
          margin-bottom: 15px;
        }

        &:nth-child(2) {
          flex-direction: column;
          align-items: center;
        }
        .sub_link {
          flex: 1 0 auto;
          text-align: center;
          font-size: 20px;
          font-weight: 600;
          cursor: pointer;
          > a {
            color: #8f8f8f;
            &.active {
              color: #ff6400;
            }
          }
        }
      }
      .sns_btn_group {
        display: flex;
        justify-content: center;
        .sns_btn {
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100% 100%;
          width: 45px;
          height: 45px;
          margin: 0 28px;
          cursor: pointer;
          transition: background-image 0.3s ease-in-out;
          &.yt {
            background-image: url("~@/assets/image/footer/youtube_logo_gray_footer.png");
            &:hover {
              background-image: url("~@/assets/image/footer/youtube_logo_color_footer.png");
            }
          }
          &.is {
            background-image: url("~@/assets/image/footer/insta_logo_gray_footer.png");
            &:hover {
              background-image: url("~@/assets/image/footer/insta_logo_color_footer.png");
            }
          }
          &.na {
            background-image: url("~@/assets/image/footer/navertv_logo_gray_footer.png");
            &:hover {
              background-image: url("~@/assets/image/footer/navertv_logo_color_footer.png");
            }
          }
        }
      }
    }
  }
}
.m #footer {
  max-width: 765px;
  min-width: 345px;
  background-color: #f8f8f8;
  .footer_wrap {
    padding-top: 24px;
    padding-bottom: 80px;
    width: calc(100vw - 60px);
    border-top: none;
    .footer_contents {
      .footer_logo {
        width: 276.92px;
        height: 50px;
        margin-top: 80px;
        background-image: url("~@/assets/image/footer/SPOTV PLUS_footer.svg");
      }
      .footer_item {
        font-size: 24px;
        color: #717171;
        line-height: 1.4;
        transform: skew(1deg);

        &.link_area {
          margin-bottom: 70px;
        }

        .sub_link {
          font-size: 29px;
          font-weight: 900;
        }
      }
      .sns_btn_group {
        display: none;
      }
    }
  }
}
</style>
